import leiCode from './lei-code'
import addresses from './addresses'
import entityDetails from './entity-details'
import entityEvents from './entity-events'
import registrationDetails from './registration-details'
import relationshipDetails from './relationship-details'
import relationshipException from './relationship-exception'
import relationshipRegistrationDetails from './relationship-registration-details'
import relationshipPeriods from './relationship-periods'

export const challengeFields = [
  ...leiCode,
  ...addresses,
  ...entityDetails,
  ...entityEvents,
  ...relationshipDetails,
  ...registrationDetails,
  ...relationshipRegistrationDetails,
  ...relationshipException,
  ...relationshipPeriods,
]

export const getFieldByPath = (path) => challengeFields.find((f) => f.jsonPath === path) || null

export const getProperty = (path, prop) => getFieldByPath(path) ? getFieldByPath(path)[prop] : null

export const getLabelByPath = (path) => getProperty(path, 'label')
export const getTypeByPath = (path) => getProperty(path, 'type')
export const getExceptByPath = (path) => getProperty(path, 'except')
export const getTextByPath = (path) => getProperty(path, 'text')
export const getProposeTextByPath = (path) => getProperty(path, 'proposeText')
export const getFieldIdByPath = (path) => getProperty(path, 'fieldId')
export const getGetValueByPath = (path) => getProperty(path, 'getValue')
export const getAlternativeInputByPath = (path) => getProperty(path, 'alternativeInput')
export const getAllowUnsetByPath = (path) => getProperty(path, 'allowUnset')



// WEBPACK FOOTER //
// ./src/utils/challenge/index.js